<template>
  <div>
    <div class="table-responsive employee-table-wrapper pb-0">

        <div class="ibox-title dashboard_title company-form-box-title pl-0 mb-3">
            <h4 class="clearfix">
                <span class="float-left">Swap Request List (Approved)</span>
                <span class="float-right"></span>
            </h4>
        </div>
      <table class="employee-list-table table table-hover dataTable table-overflow table-sticky">
        <thead class="table-head">
        <tr class="table-head">
          <th v-for="column in columns" :key="column.name" @click="sortBy(column.name)" :class="sortKey == column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" class="cursor-pointer"><span>{{column.label}}</span></th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="swap in paginatedData" :key="swap.id" class="hover-bg table-row border-bottom mx-2">
          <td >
            {{ swap.from_employee_name }}
          </td>
          <td v-b-tooltip.hover.top="swap.from_shift.start_time + '-' + swap.from_shift.end_time">{{ swap.from_shift.name }} {{ swap.from_shift.code }}</td>
          <td>{{ swap.from_date }}</td>
          <td>
            {{ swap.to_employee_name }}
          </td>
          <td v-b-tooltip.hover.top="swap.to_shift.start_time + '-' + swap.to_shift.end_time">{{ swap.to_shift.name }} {{ swap.to_shift.code }}</td>
          <td>{{ swap.to_date }}</td>
          <td class="reason-text">
            {{ swap.reason }}
          </td>
          <td >
            {{ swap.updated_by }}
          </td>

          <td class="text-center">
            <span class="leave-status" v-if="swap.status == 1"><i class="far fa-dot-circle mr-1 text-success"></i>Approved</span>
            <span class="leave-status" v-else-if="swap.status == 0"><i class="far fa-dot-circle mr-1 text-primary"></i>Applied</span>
            <span class="leave-status" v-else-if="swap.status == 2"><i class="far fa-dot-circle mr-1 text-danger"></i>Declined</span>
          </td>
        </tr>
        </tbody>

      </table>

      <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">No Result Found!</div>
      <div v-else class="p-3">
        <ul class="pagination b-pagination float-left mb-0 mt-1">
          <li class="page-item disabled m-2">View</li>
          <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
          <li class="page-item disabled m-2">per page. Total {{swapData.length}} records found.</li>
        </ul>
        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>

      </div>
    </div>
  </div>
</template>


<script>
export default {
  props:['swaps', 'status'],
  data () {
    let sortOrders = {};

    let columns = [
      {label: 'From Employee', name: 'from_name'},
      {label: 'From Shift', name: 'from_shift'},
      {label: 'From Shift Date', name: 'from_date'},
      {label: 'To Employee', name: 'to_name'},
      {label: 'To Shift', name: 'to_shift'},
      {label: 'To Shift Date', name: 'to_date'},
      {label: 'Reason', name: 'reason'},
      {label: 'Updated By', name: 'updated_by'},
      {label: 'Status', name: 'status'},
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      swapData: [],
      page: 1,
      columns: columns,
      sortOrders: sortOrders,
      sortKey: 'from_name',
      perPage: 10,
      totalRows: 0,
      totalPages: null,
      loading: false,
      selectedShift: null,

      fromEmployeeOptions: [],
      toEmployeeOptions: [],

      employees: [],
      shifts: [],
      shiftOptions: [],
      employeeShifts: [],
      fdata: {
        date: '',
        shift_id: null,
        from_employee_id: null,
        to_employee_id: null,
        reason: '',
        start: '',
        end: '',
        target_date: '',
        target_shift: null,
      },
      employee_id: 0,
      fromAssignment: {},
      toAssignment: {},

      pagination: {currentPage: 1, pages: 1},
      length_options:
          [
            {value: 20, text: "20"},
            {value: 50, text: "50"},
            {value: 100, text: "100"},
            {value: 500, text: "500"},
            {value: 1500, text: "1500"},
          ],
      temp_length: 100,
    }
  },
  mounted() {
    this.swapData = this.swaps;
  },
  methods: {
    approve(id) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to approve this employee Shift Swap?', {
        okTitle: 'Approve',
        okVariant: 'success',
        cancelTitle: 'Cancel',
        centered: true,
      }).then(ok => {
        if (!ok) return;
        axios.post(`/leave-attendance/swaps/${id}/approve`).then(response => {
          this.$bvToast.toast('Swap approved.', { variant: 'success', solid: true, title:'Success' })
          this.$emit('childToParent');
        }).catch(e=>{
          this.serverError(e);
        })
      });
    },
    reject (id) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to reject this Shift Swap?', {
        okTitle: 'Reject',
        okVariant: 'danger',
        cancelTitle: 'Cancel',
        centered: true,
      }).then(ok => {
        if (!ok) return;
        axios.post(`/leave-attendance/swaps/${id}/reject`).then(response => {
          this.$bvToast.toast('Swap rejected.', { variant: 'success', solid: true, title: 'Success' })
          this.$emit('childToParent');
        }).catch(e=>{
          this.serverError(e);
        })
      });
    },
  },
  computed: {
    filteredData()
    {
      let filtered_list = this.swapData;
      if (this.search)
      {
        filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});
      }
      let sortKey = this.sortKey;
      let order = this.sortOrders[sortKey] || 1;
      if (sortKey)
      {
        filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
              a = String(a[sortKey]).toLowerCase();
              b = String(b[sortKey]).toLowerCase();
              if (this.columns[index].type && this.columns[index].type == 'date')
              {
                return (a == b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
              }
              else if (this.columns[index].type && this.columns[index].type == 'number')
              {
                return (+a == +b ? 0 : +a > +b ? 1 : -1) * order;
              }
              else
              {
                return (a == b ? 0 : a > b ? 1 : -1) * order;
              }
            }
        );
      }
      return filtered_list;
    },
    paginatedData()
    {
      return this.paginate(this.filteredData, this.temp_length, this.pagination.currentPage);
    },
    working() {
      const mins = this._netMinutes(this.fdata)
      const hh = Math.floor(mins / 60)
      const mm = String(mins % 60).padStart(2, '0')
      return {
        minutes: mins,
        hhmm: `${hh}:${mm}`,
        decimal: (mins / 60).toFixed(2),
      }
    },
  },
}
</script>
